'use strict';

import Vue from 'vue';
import VueRouter from 'vue-router';
import $ from 'jquery';

Vue.use(VueRouter);

// Route Components
import Main from '@/views/Main';
import FAQs from '@/views/FAQs';
import Contact from '@/views/Contact';

const Router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: FAQs
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ]
});

Router.beforeEach((to, from, next) => {
  $(document).scrollTop(0);

  next();
});

export default Router;



// WEBPACK FOOTER //
// ./src/router/index.js